import { render, staticRenderFns } from "./PostDisplay.vue?vue&type=template&id=75606e8f&"
import script from "./PostDisplay.vue?vue&type=script&lang=js&"
export * from "./PostDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PostDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports